import type { SupportedLocale } from './localeConfig';

export const LOCALE_FALLBACKS: Record<SupportedLocale, SupportedLocale[]> = {
  en: ['en'],
  de: ['de', 'en'],
  fr: ['fr', 'en'],
  it: ['it', 'en'],
  es: ['es', 'en'],
  pl: ['pl', 'en'],
  sv: ['sv', 'en'],
  nl: ['nl', 'en'],
  pt: ['pt', 'en'],
  el: ['el', 'en'],
  fi: ['fi', 'en'],
  da: ['da', 'en'],
  hu: ['hu', 'en'],
  cs: ['cs', 'en'],
  sk: ['sk', 'en'],
  sl: ['sl', 'en'],
  et: ['et', 'en'],
  lv: ['lv', 'en'],
  lt: ['lt', 'en'],
  hr: ['hr', 'en'],
  ro: ['ro', 'en'],
  bg: ['bg', 'en'],
};
